module.exports = __webpack_public_path__ + "static/webinar-dr-rose-c73d46e97696f6c07d4e6a7d6f7d1e42.jpg";